module.exports = __webpack_public_path__ + "static/media/rainmatter-foundation.6cfd9a1e.png";